<template>
  <div class="ai-assistant-modal-overlay" @click.self="$emit('close')">
    <div class="ai-assistant-modal-content">
      <div class="modal-header">
        <span>AI助手</span>
        <button class="close-button" @click="$emit('close')">&times;</button>
      </div>
      <div class="modal-body">
        <iframe :src="iframeSrc" width="100%" height="100%" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIAssistantModal',
  data() {
    return {
      iframeSrc:
        'https://1095231984469331.appflow.aliyunnest.com/webhook/home/b271bff12ddb237d50cbcb5dc88c3fb074f534e2008fff12439ec736407397e69c9e0fc744108963f4/index',
    };
  },
};
</script>

<style scoped lang="scss">
.ai-assistant-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 2000;
  pointer-events: none;
}

.ai-assistant-modal-content {
  position: absolute;
  right: 8%;
  bottom: calc(10% + 65px);
  background-color: white;
  border-radius: 8px;
  width: 400px;
  height: 600px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  pointer-events: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px;
  background: linear-gradient(to right, #5195d3, #314053);
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.modal-header span {
  font-weight: bold;
}

.close-button {
  background: #606e7e;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 50%;
  font-size: 16px;
}

.modal-body {
  flex-grow: 1;
  padding: 0;
  overflow: hidden;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

iframe {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
